import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { ILOGPRE } from '@/types/base.d';
import { ITrialForm } from '@/types/trial.d';
import api from '@/api/trial';

@Component
export default class formMixin extends Vue {
  public log: ILOGPRE = {
    name: '试听课管理 - 模态框 -',
    component: 'org/trial/components/bModal',
  };

  public form: ITrialForm = {
    title: '',
    type: '',
    knowledges: [],
    content: '',
  };

  private loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    title: [
      { required: true, message: '标题不能为空' },
    ],
    type: [
      { required: true, message: '类型不能为空' },
    ],
    content: [
      { required: true, message: '内容不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑正式课信息
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        if (title.includes('编辑')) {
          api.editTrial(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.addTrial(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }
}
